import React, { Component, Fragment } from 'react';
import { Route, Link } from "react-router-dom";

import Hidden from '@material-ui/core/Hidden';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MobileNavigation from './MobileNavigation';

import nav from '../nav.js';

class Navigation extends Component {

  match = (location, name) => {
    if (!location) return;
    const levels = location.pathname.split('/');
    if (levels[1] === name) {
      return location.pathname;
    }
  }

  render() {
    return(
      <Route
        path="/"
        render={({ location, match }) => {
          return (
            <Fragment>
              <Hidden smDown>
                <Tabs value={location.pathname}>
                {
                  nav.map((n, i) => {
                    const Icon = n.icon;
                    return (
                      <Tab label={n.title}
                        key={i}
                        value={n.link}
                        component={Link}
                        to={n.link}
                        icon={<Icon />}
                      />
                    )}
                  )
                }
                </Tabs>
              </Hidden>

              <MobileNavigation items={nav} />
            </Fragment>
          )
        }
      }
      />
    );
  }
}

export default Navigation;
